import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useCallback } from 'react';

dayjs.extend(utc);
dayjs.extend(timezone);

export const useTimestamp = () => {
  const formatTime = useCallback(
    (value: number, format: string) => {
      return dayjs.unix(value).format(format);
    },
    [timezone],
  );

  return { formatTime };
};
